var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4afotyxxya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 0v844H0V0h390z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f9zu2pajb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0v.348L8.348 16h-.35V8H0v-.348L15.652.001H16z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4afotyxxya)",
    transform: "translate(-16 -296)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f9zu2pajb)",
    transform: "translate(16 296)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C21",
    d: "M0 0h16v16H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.99bac9f50b80c5502993b73fd0489287.svg";
export { ForwardRef as ReactComponent };